import React, { useState, useEffect } from 'react';
import { EnvelopeIcon } from '@heroicons/react/24/outline';
import FormInput from '../ui/FormInput';

/**
 * Email input component with validation
 */
const EmailInput = ({ 
  label, 
  value, 
  onChange, 
  showValidation = true, 
  validationMessage,
  userLang,
  onValidationChange,
  className,
  required = false,
  ...props 
}) => {
  const [validationError, setValidationError] = useState('');
  const [touched, setTouched] = useState(false);
  
  // Email validation regex
  const validateEmail = (email) => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };
  
  const handleChange = (e) => {
    const newValue = e.target.value;
    
    if (!touched) {
      setTouched(true);
    }
    
    // Call parent onChange handler
    onChange(e);
    
    // Validate email if showValidation is true
    if (showValidation) {
      validateEmailValue(newValue);
    }
  };
  
  const validateEmailValue = (emailValue) => {
    let error = '';
    
    if (!emailValue && required) {
      error = userLang === 'zh-CN' ? '请输入电子邮箱' : 'Email is required';
    } else if (emailValue && !validateEmail(emailValue)) {
      error = userLang === 'zh-CN' ? '请输入有效的电子邮箱地址' : 'Please enter a valid email address';
    }
    
    setValidationError(error);
    
    // Notify parent if callback exists
    if (onValidationChange) {
      onValidationChange(error ? [error] : []);
    }
    
    return error;
  };
  
  const handleBlur = () => {
    if (!touched) {
      setTouched(true);
    }
    
    // Validate on blur if showValidation is true
    if (showValidation && value) {
      validateEmailValue(value);
    }
  };
  
  // Validate when value changes
  useEffect(() => {
    if (showValidation && touched) {
      validateEmailValue(value);
    }
  }, [value, showValidation, touched]);
  
  return (
    <FormInput
      label={label}
      value={value}
      onChange={handleChange}
      onBlur={handleBlur}
      error={touched && showValidation ? validationError : props.error}
      type="email"
      leftIcon={<EnvelopeIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />}
      className={className}
      required={required}
      fluid
      {...props}
    />
  );
};

export default EmailInput; 